import moment from "moment";
import { ProjectModel } from "../../projects/models/project.model";
import { BudgetModel } from "./budget.model";
import { ProposalModel } from "./proposal.model";
import { RequirementModel } from "./requirement.model";

export enum ProductType {
  PRODUCT = 'PRODUCT',
  TRIP = 'TRIP',
  EQUIPMENT = 'EQUIPMENT',
  OTHER = 'OTHER',
}

export class ProductModel {
  public id: number;

  public description: string;
  public quantity: number;
  public price: number;
  public discount: number;
  public vat: number;
  public total: number;

  public projectResource: boolean;
  public type: ProductType;
  public uploadedFiles: any[]

  public requirementId: number | null;
  public budgetId: number | null;
  public proposalId: number | null;
  public projectId: number | null;

  public requirement: RequirementModel | null;
  public budget: BudgetModel | null;
  public proposal: ProposalModel | null;
  public project: ProjectModel | null;

  public createdAt: Date;
  public updatedAt: Date;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.description = $obj && $obj.description ? $obj.description : '';
    this.quantity = $obj && $obj.quantity ? $obj.quantity : 0;
    this.price = $obj && $obj.price ? $obj.price : 0.00;
    this.discount = $obj && $obj.discount ? $obj.discount : 0.00;
    this.vat = $obj && $obj.vat ? $obj.vat : 0.00;
    this.total = $obj && $obj.total ? $obj.total : 0.00;

    this.projectResource = $obj && $obj.projectResource ? $obj.projectResource : false;
    this.type = $obj && $obj.type ? $obj.type : ProductType.PRODUCT;
    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];

    this.requirementId = $obj && $obj.requirementId ? $obj.requirementId : $obj && $obj.requirement ? $obj.requirement.id : null;
    this.budgetId = $obj && $obj.budgetId ? $obj.budgetId : $obj && $obj.budget ? $obj.budget.id : null;
    this.proposalId = $obj && $obj.proposalId ? $obj.proposalId : $obj && $obj.proposal ? $obj.proposal.id : null;
    this.projectId = $obj && $obj.projectId ? $obj.projectId : $obj && $obj.project ? $obj.project.id : null;

    this.requirement = $obj && $obj.requirement ? new RequirementModel($obj.requirement) : null;
    this.budget = $obj && $obj.budget ? new BudgetModel($obj.budget) : null;
    this.proposal = $obj && $obj.proposal ? new ProposalModel($obj.proposal) : null;
    this.project = $obj && $obj.project ? new ProjectModel($obj.project) : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
  }

  setByForm(form: any, type: ProductType) {
    if (form.id) this.id = form.id;
    this.description = form.description;
    this.quantity = parseInt(form.quantity);
    this.price = parseFloat(form.price);
    this.discount = parseFloat(form.discount);
    this.vat = form.vat ? parseFloat(form.vat) : 0;
    this.total = parseFloat(form.total);
    this.requirementId = form.requirement && form.requirement !== '' ? form.requirement : null;
    this.type = type;
    return this;
  }

  toAPI() {
    return {
      description: this.description,
      quantity: this.quantity,
      price: this.price,
      discount: this.discount,
      vat: this.vat,
      total: this.total,
      projectResource: this.projectResource,
      requirementId: this.requirementId,
      budgetId: this.budgetId,
      proposalId: this.proposalId,
      projectId: this.projectId,
      type: this.type
    };
  }

  toBudgetAPI(create: boolean) {
    if (create) {
      return {
        description: this.description,
        quantity: this.quantity,
        price: this.price,
        discount: this.discount,
        vat: this.vat,
        total: this.total,
        type: this.type,
        requirementId: this.requirementId
      };
    } else {
      return {
        id: this.id,
        description: this.description,
        quantity: this.quantity,
        price: this.price,
        discount: this.discount,
        vat: this.vat,
        total: this.total,
        projectResource: this.projectResource,
        type: this.type,
        requirementId: this.requirementId
      };
    }

  }
}
